/* eslint-disable react/jsx-pascal-case */
// Name2 
import {
    Button,
    Input,
    Textarea,
    toast,
    Label,
    CrmContainerTitle1_1,
    CrmCategoryMenu1_1,
    CrmSelect2,
    CrmFileUpload1,
    CrmChart1,
    AIGenerateButton,
    message,
    jsonToQueryString,
    useCRUDController,
    generateComponentsOutput,
    applyResponsiveLayout
} from './ot'
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { Plus, } from "lucide-react"
import dayjs from 'dayjs'
import BaseInfoBlock2 from "./base_info_block_2"
import CrmInfoView from "../crm_base/crm_info_view"
import BaseChart from "./base_chart"
import { LucideIcon } from './ot'
import { useTranslation } from 'react-i18next'
import ComponentQuantityPanel from './component_quantity_panel';
/**
 * Name2要在empty_draft的document_create_method_data預設是
[
  {
    "create_method_id": 1
  }
]
 */
const Name2 = ({
    propsCategoryName = '',
    propsCategoryTitle = '',
    propsPrimaryColorName = 'green',
    propsPrimaryColor = "#134e4a",
    propsSecodaryColor = 'green',
    propsBackgroundColor = "linear-gradient(to right, #f0fdfa, #f0fdf4)",
    selectionAPIRoute = '/utility/selection/base_classify_structure_data', // 拿下拉選單的 route
    selectionApiRoute = null, // 拿下拉選單的 route 更名
    templateAPIRoute = '/utility/document/base_on_classify_structure', // 拿範本的 route
    templateApiRoute = null, // 拿範本的 route 更名
    folderAPIRoute = '/utility/folder', // 拿資料夾的 route 更名
    folderApiRoute = null,// 拿資料夾的 route 更名
    dbCoverIdName = 'document_id', // 用來判斷編輯或新增的 id name ex:xx_id

    mainAPIRoute = '/utility/document',//新增修改的 api
    mainApiRoute = null,//新增修改的 api 更名
    propsGetBaseCardViewData, //系統預設範本卡片資料轉換函式
    propsGetBaseListViewData, //列表資料轉換函式
    pageFrontendRoute = '/utility/document/_3',//前端路徑，新增完成後重整用
    isPropsSubmit = false, //是否由父層處理提交 submit 資料
    isReferenceArchitecture = false, // 是否為參考架構
    referenceArchitectureAPIRoute = '',
    showChart = false,
    zeroCreateName = "",
    handleSubmit = () => { },
    defaultValues,
    defaultElements = [
        {
            "component_definitions_id": 14,
            "id": "text-content-" + Date.now(),
            "type": "text-content",
            "content": "",
            // "hidden": 1,
            "x": {
                "desktop": 43,
                "tablet": 191,
                "mobile": 191
            },
            "y": {
                "desktop": 32.5,
                "tablet": 124.5,
                "mobile": 124.5
            },
            "xLegacy": 191,
            "yLegacy": 124.5,
            "width": 300,
            "height": 60,
            "style": {
                "fontSize": "16px",
                "lineHeight": "1.5",
                "padding": "10px",
                "backgroundColor": "#fff"
            },
            "title": "",
            "form_form_column_data": [
                {
                    "code": "名稱",
                    "is_required": "1",
                    "default_value": "",
                    "placeholder": "請輸入名稱",
                    "help_text": "",
                    "form_column_validation_data": [
                        {
                            "max_text_number": 99,
                            "min_text_number": 0,
                            "min_value": 0,
                            "max_value": 999,
                            "disable_special_character": 0,
                            "only_allow_chinese": 0,
                            "only_allow_english": 0,
                            "wrong_message": "",
                            "validation_classify_structure_type_data": [
                                {
                                    "name_language_data": [
                                        {
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": ""
                                        }
                                    ]
                                }
                            ],
                            "validation_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "form_column_selection_option_data": []
                }
            ]
        },
        {
            "component_definitions_id": 89,
            "id": "textarea-" + Date.now(),
            "type": "textarea",
            "content": "",
            // "hidden": 1,
            "x": {
                "desktop": 54,
                "tablet": 203,
                "mobile": 203
            },
            "y": {
                "desktop": 188.5,
                "tablet": 256.5,
                "mobile": 256.5
            },
            "xLegacy": 203,
            "yLegacy": 256.5,
            "width": 292,
            "height": 104,
            "style": {
                "backgroundColor": "transparent",
                "color": "#000",
                "fontSize": "16px",
                "fontWeight": "bold",
                "display": "flex",
                "alignItems": "center",
                "justifyContent": "center",
                "cursor": "pointer",
                "width": 292,
                "height": 104
            },
            "form_form_column_data": [
                {
                    "code": "描述",
                    "is_required": "1",
                    "form_column_validation_data": [
                        {
                            "max_text_number": 99,
                            "min_text_number": 0,
                            "min_value": 0,
                            "max_value": 999,
                            "disable_special_character": 0,
                            "only_allow_chinese": 0,
                            "only_allow_english": 0,
                            "validation_classify_structure_type_data": [
                                {
                                    "name_language_data": [
                                        {
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": ""
                                        }
                                    ]
                                }
                            ],
                            "validation_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "form_column_selection_option_data": []
                }
            ]
        },
        {
            "component_definitions_id": 188,
            "id": "upload_img-" + Date.now(),
            "type": "upload_img",
            "content": "",
            // "hidden": 1,
            "x": {
                "desktop": 66,
                "tablet": 214,
                "mobile": 214
            },
            "y": {
                "desktop": 344.5,
                "tablet": 388.5,
                "mobile": 388.5
            },
            rwdHeight: {
                "desktop": 104,
                "tablet": 104,
                "mobile": 104
            },
            rwdWidth: {
                "desktop": 292,
                "tablet": 292,
                "mobile": 292
            },
            "xLegacy": 203,
            "yLegacy": 256.5,
            "width": 292,
            "height": 104,
            "style": {
                "backgroundColor": "transparent",
                "color": "#000",
                "fontSize": "16px",
                "fontWeight": "bold",
                "display": "flex",
                "alignItems": "center",
                "justifyContent": "center",
                "cursor": "pointer",
                "width": 292,
                "height": 104
            },
            "form_form_column_data": [
                {
                    "code": "圖片",
                    "is_required": "0",
                    "form_column_validation_data": [
                        {
                            "max_text_number": 99,
                            "min_text_number": 0,
                            "min_value": 0,
                            "max_value": 999,
                            "disable_special_character": 0,
                            "only_allow_chinese": 0,
                            "only_allow_english": 0,
                            "validation_classify_structure_type_data": [
                                {
                                    "name_language_data": [
                                        {
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": ""
                                        }
                                    ]
                                }
                            ],
                            "validation_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "form_column_selection_option_data": []
                }
            ]
        }
    ],
    displayAIGenerate = true,
    keyPrefix = "/ad_plan/report/_2",
    componentDefinitionsApiRoute = "/ad_plan_management/backend/content_component_definitions/base_view"
}) => {
    const finalSelectionApiRoute = selectionApiRoute ?? selectionAPIRoute
    const { t } = useTranslation("translation", { keyPrefix })
    const finalTemplateApiRoute = templateApiRoute ?? templateAPIRoute
    const finalFolderApiRoute = folderApiRoute ?? folderAPIRoute
    const finalMainApiRoute = mainApiRoute ?? mainAPIRoute

    const dbName = dbCoverIdName.replace('_id', '') //為了在post 資料的時候可以通用 ${dbName}_document_x_document_data
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [contentName, setContentName] = useState("");
    const [aiPrompt, setAiPrompt] = useState("");
    const [description, setDescription] = useState("");
    const [folderSelection, setFolderSelection] = useState(null);
    const [architectureData, setArchitectureData] = useState([]);
    const [architectureValues, setArchitectureValues] = useState(null);
    const [AiFolderSelection, setAiFolderSelection] = useState("");
    const [uploadedRequirementFiles, setUploadedRequirementFiles] = useState([]);
    const [chartData, setChartData] = useState({});
    const [folderData, setFolderData] = useState([]);
    const [templateSelectionDataChanged, setTemplateSelectionDataChanged] = useState([]);
    const [aiProduceAPIRoute, setAiProduceAPIRoute] = useState('/space_management/backend/ai_generate/template');
    const [selectionData, setSelectionData] = useState([]); //新的下拉選單組
    const [dbCoverId, setDBCoverId] = useState(null);
    const [folderLoading, setFolderLoading] = useState(true);
    // ─── AI 元件數量建議 ───────────────────────────────────────────────────────
    const [componentQuantityCounts, setComponentQuantityCounts] = useState({});
    // 驗證 contentName：不可為空或僅有空白，且至少包含一個文字或數字字元
    const isValidContentName = (v) => {
        if (typeof v !== 'string') return false;
        if (v.trim().length === 0) return false;
        // 要求至少有一個字母或數字（包含中文等文字類別）
        try {
            return /[\p{L}\p{N}]/u.test(v);
        } catch (e) {
            // 若環境不支援 Unicode property，退回到簡單的字元檢查：英數或漢字範圍
            return /[A-Za-z0-9\u4e00-\u9fff]/.test(v);
        }
    }

    //拿下拉選單資料
    const getSelectionData = () => {
        // 取得下拉選單資料
        SelectionController.getData()
            .then((res) => {
                // let data = res?.data || []
                let data = res?.data || []
                let selectionDataTemp = data.filter((item) => {
                    return !!item?.selection_id
                })?.map(item => {
                    let selection_classify_structure_type_data = item?.selection_classify_structure_type_data || []
                    let selection_classify_structure_type_data_first = selection_classify_structure_type_data?.find((_) => true)

                    //選項資料 selection_option_id、title
                    let selection_selection_option_data = (selection_classify_structure_type_data_first?.selection_selection_option_data || []).map((option) => {
                        let selection_option_classify_structure_type_data = option?.selection_option_classify_structure_type_data || []
                        let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data?.find((_) => true)

                        return {
                            ...option,
                            label: option?.name,
                            name: option?.name,
                            description: selection_option_classify_structure_type_data_first?.selection_option_description || "",
                            value: option?.name,
                            id: option?.selection_option_id
                        }
                    })
                    return {
                        // 選單設定
                        label: item?.title || item?.selection_name,
                        name: item?.title || item?.selection_name,
                        label_icon: selection_classify_structure_type_data_first?.selection_icon,
                        placeholder: selection_classify_structure_type_data_first?.selection_placeholder,
                        selection_id: item?.selection_id,
                        component_type: "MULTISELECT",  //強制多選

                        // 選項設定
                        // component_type: selection_classify_structure_type_data_first?.component_type,
                        ...selection_classify_structure_type_data_first,
                        selection_selection_option_data
                    }
                }) || []
                setSelectionData(selectionDataTemp)
            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    //拿選擇後的folder 資料  document_file_data
    const getSelectFolderData = (folder_id) => {
        let selectFolderData = folderData.find((ele) => {
            return ele?.folder_id === folder_id
        })
        let document_file_data = [
            {
                folder_classify_structure_type_data: selectFolderData?.folder_classify_structure_type_data,
                file_folder_data: [
                    {
                        "folder_id": folder_id
                    }
                ]
            }
        ]
        return document_file_data
    }
    const getArchitectureData = () => {
        ArchitectureController.getData()
            .then((res) => {
                let data = res?.data || []
                data = data?.map((value) => {
                    return {
                        ...value,
                        value: value?.classify_structure_type_id
                    }
                })
                setArchitectureData(data)
            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    const getBaseCardViewData = (data) => {
        let newdata = data.map((value) => {
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_value
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)

            return {
                key: value?.key,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s"
                },
                baseCardView1_3Props: {
                    value: twName || '-',
                },
                baseCardView1_4Props: {
                    value: document_classify_structure_type_data_first?.document_description || '-',
                },
                baseCardView1_5Props: {
                    stats: [
                        {
                            value: document_classify_structure_type_data_first?.view_times,
                            label: t('瀏覽次數'),
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"Eye"} className="w-4 h-4  text-blue-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.clone_times,
                            label: t('撰寫') + propsCategoryTitle,
                            backgroundColor: "bg-" + propsPrimaryColorName + "-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"FileText"} className="w-4 h-4  text-green-500" />,
                        },
                        {
                            value: document_classify_structure_type_data_first?.click_times,
                            label: t('點擊次數'),
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"MousePointer"} className="w-4 h-4  text-purple-500" />

                        },
                        {
                            value: document_classify_structure_type_data_first?.copy_times,
                            label: "複製次數",
                            backgroundColor: "bg-" + propsPrimaryColorName + "-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"TrendingUp"} className="w-4 h-4  text-orange-500" />

                        },
                    ]
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name || '-',
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: document_classify_structure_type_data_first?.create_time ? dayjs(document_classify_structure_type_data_first?.create_time).format("YYYY-MM-DD") : "-",
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    //尚未串接
                    children: <p className="text-gray-600 mt-1 text-sm">{'儲存位置：.../.../...'}</p>
                },
                baseCardView1_8Props: {
                    buttons: [
                        <Button
                            onClick={() => {
                                // handleDefaultTemplateClick(value);
                                onMainAPISubmit("system_template", value)
                            }}
                            variant="outline" className="flex-1">
                            {t('使用此')}{propsCategoryName}{propsCategoryTitle}
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            }
        })
        return newdata
    }
    const getBaseListViewData = (data) => {
        let newdata = data.map((value) => {
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value || "-"

            return {
                key: "1",
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: twName,

                },
                baseListView1_3Props: {
                    value: document_classify_structure_type_data_first?.document_description || "-",
                },
                baseListView1_4Props: {
                    stats: [
                        {
                            value: document_classify_structure_type_data_first?.view_times,
                            label: t('瀏覽次數'),
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"Eye"} className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.clone_times,
                            label: t('撰寫') + propsCategoryTitle,
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"FileText"} className="h-4 w-4 text-green-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.click_times,
                            label: t('點擊次數'),
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"MousePointer"} className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: document_classify_structure_type_data_first?.copy_times,
                            label: t('複製次數'),
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"TrendingUp"} className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: document_classify_structure_type_data_first?.create_time ? dayjs(document_classify_structure_type_data_first?.create_time).format("YYYY-MM-DD") : "-",
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseListView1_6Props: {
                    children: <p className="text-gray-600 mt-1 text-sm">儲存位置</p>
                },
                baseListView1_7Props: {
                    buttons: [
                        <Button
                            onClick={() => {
                                // handleDefaultTemplateClick(value);
                                onMainAPISubmit("system_template", value)
                            }}
                            variant="outline" className="flex-1">
                            {t('使用此')}{propsCategoryName}{propsCategoryTitle}
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            }
        })
        return newdata
    }
    const handleTemplateSelectionDataChange = (newTemplateSelectionData) => {
        setTemplateSelectionDataChanged(newTemplateSelectionData);
    };
    const handleDefaultTemplateClick = (oldTemplate) => {
        TemplateController.postData([
            { ...oldTemplate, is_new_post_mode: true },
        ]);
    };
    const TemplateonStatisticsBefore = ({ axiosMode, status, values }) => {
    };
    const TemplateonStatisticsFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                setChartData(values)
            } else if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "import") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        }
    };


    const TemplateBefore = ({ axiosMode, status, values }) => {
    };
    const TemplateFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
            } else if (axiosMode === "post") {
                if (values?.restful_mode == 'insert') {
                    toast({
                        title: "新增" + propsCategoryName + "成功",
                    });
                } else {
                    toast({
                        title: "帶入預設" + propsCategoryName + "成功",
                    });
                }
                navigate(`/space_management/content_writing/_3?template_id=${values?.template_id}`);

            } else if (axiosMode === "patch") {
            } else if (axiosMode === "import") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        }
    };
    const TabContentRenderFunction = (item) => {
        if (item?.key === 'new') {
            return (
                <div className={`grid grid-cols-${displayAIGenerate ? 2 : 1} gap-8`}>
                    <div className={"p-4 border border-" + propsPrimaryColorName + "-200 rounded-lg bg-white"}>
                        <div className="flex items-center justify-between mb-4">
                            <div className={"bg-" + propsPrimaryColorName + "-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0"}>
                                {item?.["BlockA"]?.["basicData"]?.["iconLabel"]}
                            </div>
                            <h3 className={"text-lg font-medium text-" + propsPrimaryColorName + "-800"}>{item?.["BlockA"]?.["basicData"]?.["title"]}</h3>
                            <Button
                                onClick={() => {
                                    onMainAPISubmit("empty_draft", { contentName, description, architectureValues, folderSelection })
                                }}
                                disabled={isLoading || !isValidContentName(contentName)}
                                className={"bg-" + propsPrimaryColorName + "-600 hover:bg-" + propsPrimaryColorName + "-700"}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="mr-2 h-4 w-4 animate-spin inline-block rounded-full border-2 border-current border-t-transparent" />
                                        {item?.["BlockA"]?.["basicData"]?.["processText"]}
                                    </>
                                ) : (
                                    <>
                                        {item?.["BlockA"]?.["basicData"]?.["titleIcon"]}
                                        {item?.["BlockA"]?.["basicData"]?.["title"]}
                                    </>
                                )}
                            </Button>
                        </div>
                        <p className={"mb-6 text-sm text-" + propsPrimaryColorName + "-700 "}>
                            {item?.["BlockA"]?.["basicData"]?.["tabDescription"]}
                        </p>
                        <div className="space-y-4 ">
                            <div>
                                <Label htmlFor="content-name" className="flex items-center">
                                    {item?.["BlockA"]?.["formData"]?.[0]?.['label']}
                                    <span className="text-red-500 ml-1">*</span>
                                    <span className="text-xs text-muted-foreground ml-2">(必填)</span>
                                </Label>
                                <div className="flex items-center mt-1">
                                    <Input
                                        id="content-name"
                                        placeholder={item?.["BlockA"]?.["formData"]?.[0]?.['placeholder']}
                                        value={contentName}
                                        onChange={(e) => setContentName(e.target.value)}
                                        className="flex-1"
                                    />
                                </div>
                            </div>
                            <div>
                                <Label htmlFor="template-description">{item?.["BlockA"]?.["formData"]?.[1]?.['label']}</Label>
                                <Textarea
                                    id="template-description"
                                    placeholder={item?.["BlockA"]?.["formData"]?.[1]?.['placeholder']}
                                    onChange={(e) => setDescription(e.target.value)}
                                    className="mt-1 min-h-[80px]"
                                />
                            </div>
                            <div>
                                <Label htmlFor="content-category" className="flex items-center">
                                    {item?.["BlockA"]?.["formData"]?.[2]?.['label']}
                                    <span className="text-xs text-muted-foreground ml-2">(選填)</span>
                                </Label>
                                <div className="flex items-center mt-1">
                                    <div className="flex-1">
                                        <CrmSelect2
                                            CrmSelect2_2Props={
                                                {
                                                    name: "",
                                                    onValueChange: (e) => { setFolderSelection(e.target.value) },
                                                    multiple: false,
                                                    defaultValue: "",
                                                    showSearch: true,
                                                    style: {},
                                                    placeholder: item?.["BlockA"]?.["formData"]?.[2]?.['placeholder'],
                                                    allowClear: true,
                                                    treeDefaultExpandAll: false,
                                                    onChange: (e) => {
                                                        setFolderSelection(e.target.value)
                                                    },
                                                    treeData: folderData || [],
                                                    itemHeight: 36,
                                                    height: 300,
                                                    loadData: false,
                                                    value: "",
                                                    createMode: true,
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            {isReferenceArchitecture && <div>
                                <Label htmlFor="content-category" className="flex items-center">
                                    {propsCategoryName}架構參考
                                    <span className="text-xs text-muted-foreground ml-2">(選填)</span>
                                </Label>
                                <div className="flex items-center mt-1">
                                    <div className="flex-1">
                                        <CrmSelect2
                                            CrmSelect2_2Props={
                                                {
                                                    name: "",
                                                    onValueChange: (e) => {
                                                        console.log(e.target.value)
                                                        let architectureValuesTemp = architectureData?.find((ele) => ele?.classify_structure_type_id === e.target.value)
                                                        setArchitectureValues(architectureValuesTemp)
                                                    },
                                                    multiple: false,
                                                    defaultValue: "",
                                                    showSearch: true,
                                                    style: {},
                                                    placeholder: item?.["BlockA"]?.["formData"]?.[2]?.['placeholder'],
                                                    allowClear: true,
                                                    treeDefaultExpandAll: false,
                                                    onChange: (e) => {
                                                        console.log(e.target.value)
                                                        let architectureValuesTemp = architectureData?.find((ele) => ele?.classify_structure_type_id === e.target.value)
                                                        setArchitectureValues(architectureValuesTemp)
                                                    },
                                                    treeData: architectureData || [],
                                                    itemHeight: 36,
                                                    height: 300,
                                                    loadData: false,
                                                    value: "",
                                                    createMode: true,
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            </div>}
                        </div>
                        {showChart && <div className="mt-4 p-11 ">
                            <CrmChart1
                                mode="bar"
                                title={propsCategoryTitle}
                                haveTitle={false}
                                ChartStackedCategoryBarsProps={[
                                    {
                                        title: propsCategoryName + "分類",
                                        statistic_title: propsCategoryName,
                                        data: [
                                            {
                                                label: "智慧", value: 4,
                                                color: "text-blue-600",
                                                bgColor: "bg-blue-600"
                                            },
                                        ]
                                    },
                                ]}
                            />
                        </div>}
                    </div>


                    {displayAIGenerate &&
                        <div className={"p-4 border border-" + propsPrimaryColorName + "-200 rounded-lg bg-white"}>
                            <div className="flex items-center justify-between mb-4">
                                <div className={"bg-" + propsPrimaryColorName + "-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0"}>
                                    {item?.["BlockB"]?.["basicData"]?.["iconLabel"]}
                                </div>
                                <h3 className={"text-lg font-medium text-" + propsPrimaryColorName + "-800"}>{item?.["BlockB"]?.["basicData"]?.["title"]}</h3>
                                {/* <AIGenerateButton
                                    aititle={isLoading ? item?.["BlockB"]?.["basicData"]?.["processText"] : item?.["BlockB"]?.["basicData"]?.["title"]}
                                    disabled={isLoading || (!aiPrompt && uploadedRequirementFiles.length === 0)}
                                    aiButtonClassName={"bg-" + propsPrimaryColorName + "-600 hover:bg-" + propsPrimaryColorName + "-700"}
                                    propsSelectionOptions={
                                        {
                                            "template_selection_data": templateSelectionDataChanged,
                                            "ai_prompt": aiPrompt,
                                            "uploaded_requirement_files": uploadedRequirementFiles,
                                            "file_folder_data": [
                                                {
                                                    "folder_id": folderSelection,
                                                }

                                            ],
                                        }
                                    }
                                    // aiGenerateQuantityRecommendationsAPIRoute={aiProduceAPIRoute}
                                >
                                </AIGenerateButton> */}
                                <Button
                                    className={"bg-" + propsPrimaryColorName + "-600 hover:bg-" + propsPrimaryColorName + "-700"}
                                    // onClick={() => {
                                    //     let result = generateComponentsOutput(componentQuantityCounts, conponentDefinitionsController.ResponseData || [])
                                    //     onMainAPISubmit("AI", { contentName, description, architectureValues, folderSelection }, result)
                                    // }}
                                    onClick={async () => {
                                        const componentDefinitions = conponentDefinitionsController.ResponseData || []
                                        let selectionExtras = {}
                                        if (templateSelectionDataChanged && typeof templateSelectionDataChanged === 'object') {
                                            Object.entries(templateSelectionDataChanged).forEach(([key, options]) => {
                                                if (Array.isArray(options) && options.length > 0) {
                                                    selectionExtras[key] = options.map((opt) => opt?.value).filter(Boolean).join('、')
                                                }
                                            })
                                        }
                                        let selectionExtrastring = Object.entries(selectionExtras).map(([key, value]) => `${key}: ${value}`).join("\n")
                                        let componentDefinitionsData = componentDefinitions?.map((item) => {
                                            return {
                                                ...item,
                                                quantity: componentQuantityCounts[item?.component_definitions_id] || null
                                            }
                                        })
                                        const payload = [
                                            {
                                                target: "文案",
                                                input: componentDefinitionsData,
                                                "需求描述": aiPrompt + selectionExtrastring
                                            }
                                        ]
                                        console.log({
                                            componentDefinitions,
                                            componentQuantityCounts
                                        })
                                        const res = await AiControllers.postData(payload, "all")

                                        if (res?.status !== "success") {
                                            message.error("AI生成失敗")
                                            return
                                        }

                                        const elements = (res?.values?.data || []) 
                                        onMainAPISubmit(
                                            "AI",
                                            { contentName, description, architectureValues, folderSelection },
                                            elements
                                        )
                                    }}
                                    loading={isLoading}
                                // disabled={isLoading}
                                >
                                    {<LucideIcon name="Sparkles" className="w-4 h-4 mr-2" />}
                                    AI一鍵生成
                                </Button>
                            </div>
                            <p className={"mb-6 text-sm text-" + propsPrimaryColorName + "-700 "}>
                                {item?.["BlockB"]?.["basicData"]?.["tabDescription"]}
                            </p>

                            <div className="mb-8 ">
                                <BaseInfoBlock2
                                    fieldConfigs={selectionData || []}
                                    onValuesChange={(values) => { handleTemplateSelectionDataChange(values) }}
                                />
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 ">
                                <div className="space-y-4">
                                    <div>
                                        <Label htmlFor="ai-prompt" className="flex items-center">
                                            {item?.["BlockB"]?.["formData"]?.[0]?.["label"]}
                                            <span className="text-red-500 ml-1">*</span>
                                            <span className="text-xs text-muted-foreground ml-2">
                                                {item?.["BlockB"]?.["formData"]?.[0]?.["description"]}
                                            </span>
                                        </Label>
                                        <div className="flex flex-col mt-1">
                                            <Textarea
                                                id="ai-prompt"
                                                placeholder={item?.["BlockB"]?.["formData"]?.[0]?.["placeholder"]}
                                                className="min-h-[120px]"
                                                value={aiPrompt}
                                                onChange={(e) => setAiPrompt(e.target.value)}
                                            />
                                            <p className="text-xs text-muted-foreground mt-1">
                                                {item?.["BlockB"]?.["formData"]?.[0]?.["hint"]}
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <Label htmlFor="content-category" className="flex items-center">
                                            {item?.["BlockB"]?.["formData"]?.[1]?.["label"]}
                                        </Label>
                                        <div className="flex items-center mt-1">
                                            <div className="flex-1">
                                                <CrmSelect2
                                                    CrmSelect2_2Props={
                                                        {
                                                            name: "",
                                                            onValueChange: (item) => { setAiFolderSelection(item) },
                                                            multiple: false,
                                                            defaultValue: "",
                                                            showSearch: true,
                                                            style: {},
                                                            placeholder: item?.["BlockB"]?.["formData"]?.[1]?.["placeholder"],
                                                            allowClear: true,
                                                            treeDefaultExpandAll: false,
                                                            onChange: (item) => { setAiFolderSelection(item) },
                                                            treeData: folderData || [],
                                                            itemHeight: 36,
                                                            height: 300,
                                                            loadData: false,
                                                            value: "",
                                                            createMode: true,
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <CrmFileUpload1
                                    title={item?.["BlockB"]?.["formData"]?.[2]?.["title"]}
                                    description={item?.["BlockB"]?.["formData"]?.[2]?.["description"]}
                                />
                                <ComponentQuantityPanel
                                    loading={aiQuantityController?.loading}
                                    componentDefinitions={conponentDefinitionsController?.ResponseData || []}
                                    primaryColor={propsPrimaryColor}
                                    counts={componentQuantityCounts}
                                    onChange={(newCounts) => setComponentQuantityCounts(newCounts)}
                                    onAISuggest={handleAISuggest}
                                />
                            </div>
                        </div>
                    }
                </div >

            )
        }
        else {
            return (
                <div className="space-y-6">
                    <div className={"p-4 border border-" + propsPrimaryColorName + "-200 rounded-lg bg-white"}>
                        <div className="flex items-center mb-4">
                            <div className={"bg-" + propsPrimaryColorName + "-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0"}>
                                A
                            </div>
                            <h3 className={"text-lg font-medium text-" + propsPrimaryColorName + "-800"}>{t('選擇系統')}{propsCategoryTitle}{t('範本')}</h3>
                        </div>
                        <p className={"mb-4 text-sm text-" + propsPrimaryColorName + "-700 "}>
                            {t('從系統提供的預設')}{propsCategoryTitle}{t('範本中選擇一個作為起點，範本的屬性將自動帶入')}{propsCategoryTitle}{t('基本資料中。')}
                        </p>
                        <div className=" ">
                            {/* <ContentMetadataSelector metadata={contentMetadata} onMetadataChange={handleMetadataChange} /> */}
                            <BaseInfoBlock2
                                fieldConfigs={selectionData || []}
                                onValuesChange={(values) => { handleTemplateSelectionDataChange(values) }}
                            />
                        </div>
                        {/* <ContentManagement buttonMode="useOnly" templateType="system" /> */}
                        <CrmInfoView
                            showComponent={[
                                "BaseInfoView1",
                                "BaseInfoView2",
                                "BaseInfoView5",
                                "BaseInfoView6",
                            ]}
                            apiRoute={finalTemplateApiRoute}
                            categoryData={[
                                {
                                    key: "system_template",
                                    label: "系統範本",
                                    dark_mode_color: "#60a5fa",
                                    light_mode_color: "#f0f6ff",
                                }
                            ]}
                            propsGetParams={(keyArr = [], categoryDataValue) => {
                                //拿範本固定會傳送的參數
                                let params = {
                                    is_default: 1
                                }
                                return params
                            }}
                            propsGetBaseCardViewData={propsGetBaseCardViewData ? propsGetBaseCardViewData : getBaseCardViewData}
                            propsGetBaseListViewData={propsGetBaseListViewData ? propsGetBaseListViewData : getBaseListViewData}
                        />
                    </div>
                </div>
            )
        }

    }
    const removeIdFields = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(item => removeIdFields(item));
        } else if (obj !== null && typeof obj === 'object') {
            const newObj = {};
            for (const key in obj) {
                if (!key.endsWith('_id')) { // 移除所有 _id 結尾的 key
                    newObj[key] = removeIdFields(obj[key]);
                }
            }
            return newObj;
        }
        return obj; // 基本型別直接回傳
    }
    const onMainAPISubmit = (createType, values, extraElements = []) => {
        if (!!isPropsSubmit) {
            //處理 props 提交邏輯
            handleSubmit(createType, values)
            return
        }
        let defaultMainPostData = {
            // "classify_structure_type_parent_id": 0,
            "property_json": null,
            "name": null,
            "name_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": null
                }
            ],
            "document_classify_structure_type_data": [
                {
                    "document_description": null,
                    "document_category": null,
                    "document_selection_option_data": [],
                    "document_file_data": [
                        {
                            "file_classify_structure_type_data": [
                                {
                                    "name_language_data": [
                                        {
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": "23344"
                                        }
                                    ]
                                }
                            ],
                            "file_folder_data": [
                                {
                                    "folder_id": 23
                                }
                            ]
                        }
                    ],
                    "hierarchy_document_x_document_data": [
                        {
                            "last_edit_time": "2025-09-04T11:17:48.362271",
                            "create_time": "2025-09-04T11:17:48.362271"
                        }
                    ]
                }
            ]

        }
        if (createType === "empty_draft") {
            if (!isValidContentName(values?.contentName)) {
                message.error(t('請輸入名稱，且至少包含文字或數字'));
                return;
            }
            let document_file_data = []
            if (!!values?.folder_id) {
                document_file_data = getSelectFolderData(values?.folder_id)
            }
            if (!!values?.architectureValues) {
                // 先移除 _id 欄位
                defaultMainPostData = removeIdFields({ ...values?.architectureValues, "property_json": '{}' })

                // 強制覆蓋你想要的欄位
                defaultMainPostData.name = values?.contentName
                defaultMainPostData.name_language_data = [
                    {
                        "language_culture_code": "zh-tw",
                        "language_culture_value": values?.contentName
                    }
                ]
                // 覆蓋 document_classify_structure_type_data 內部欄位
                if (Array.isArray(defaultMainPostData.document_classify_structure_type_data) && defaultMainPostData.document_classify_structure_type_data.length > 0) {
                    defaultMainPostData.document_classify_structure_type_data[0] = {
                        ...defaultMainPostData.document_classify_structure_type_data[0],
                        document_description: values?.description || "",
                        document_file_data: document_file_data || [],
                        [`${dbName}_x_document_data`]: [{}], // 你可以根據需求調整內容
                    }
                }
            } else {
                defaultMainPostData = {
                    "classify_structure_type_parent_id": 0,
                    "property_json": '{}',
                    "name": values?.contentName,
                    "name_language_data": [
                        {
                            "language_culture_code": "zh-tw",
                            "language_culture_value": values?.contentName
                        }
                    ],
                    "document_classify_structure_type_data": [
                        {
                            "document_description": values?.description || "",
                            // "document_category": null, //缺下拉選單
                            "document_number": null,
                            "view_times": 0,
                            "click_times": 0,
                            "copy_times": 0,
                            "clone_times": 0,
                            "is_finish": 0,
                            "document_create_method_data": [
                                {
                                    "create_method_id": 1
                                }
                            ],
                            "document_selection_option_data": [],
                            "document_file_data": document_file_data || [],
                            "document_x_canvas_content_data": [
                                {
                                    content: [
                                        {
                                            "id": `page${Date.now()}`,
                                            "name": "頁面一",
                                            "form_column_needed": 1,
                                            "elements": applyResponsiveLayout([...defaultElements, ...extraElements])
                                        }
                                    ]
                                }
                            ],
                            "document_form_data": [{}],
                            "document_response_data": [],
                            [`${dbName}_x_document_data`]: [{
                                ...defaultValues
                            }]
                        }
                    ],
                }
            }
        }
        else if (createType === "system_template") {
            defaultMainPostData = { ...values }
            defaultMainPostData = removeIdFields({ ...values, "property_json": '{}' })

        }
        else if (createType === "AI") {
            if (!isValidContentName(values?.contentName)) {
                message.error(t('請輸入名稱，且至少包含文字或數字'));
                return;
            }
            let document_file_data = []
            if (!!values?.folder_id) {
                document_file_data = getSelectFolderData(values?.folder_id)
            }
            if (!!values?.architectureValues) {
                // 先移除 _id 欄位
                defaultMainPostData = removeIdFields({ ...values?.architectureValues, "property_json": '{}' })

                // 強制覆蓋你想要的欄位
                defaultMainPostData.name = values?.contentName
                defaultMainPostData.name_language_data = [
                    {
                        "language_culture_code": "zh-tw",
                        "language_culture_value": values?.contentName
                    }
                ]
                // 覆蓋 document_classify_structure_type_data 內部欄位
                if (Array.isArray(defaultMainPostData.document_classify_structure_type_data) && defaultMainPostData.document_classify_structure_type_data.length > 0) {
                    defaultMainPostData.document_classify_structure_type_data[0] = {
                        ...defaultMainPostData.document_classify_structure_type_data[0],
                        document_description: values?.description || "",
                        document_file_data: document_file_data || [],
                        [`${dbName}_x_document_data`]: [{}], // 你可以根據需求調整內容
                    }
                }
            } else {
                defaultMainPostData = {
                    "classify_structure_type_parent_id": 0,
                    "property_json": '{}',
                    "name": values?.contentName,
                    "name_language_data": [
                        {
                            "language_culture_code": "zh-tw",
                            "language_culture_value": values?.contentName
                        }
                    ],
                    "document_classify_structure_type_data": [
                        {
                            "document_description": values?.description || "",
                            // "document_category": null, //缺下拉選單
                            "document_number": null,
                            "view_times": 0,
                            "click_times": 0,
                            "copy_times": 0,
                            "clone_times": 0,
                            "is_finish": 0,
                            "document_create_method_data": [
                                {
                                    "create_method_id": 3
                                }
                            ],
                            "document_selection_option_data": [],
                            "document_file_data": document_file_data || [],
                            "document_x_canvas_content_data": [
                                {
                                    content: [
                                        {
                                            "id": `page${Date.now()}`,
                                            "name": "頁面一",
                                            "form_column_needed": 1,
                                            "elements": applyResponsiveLayout([...defaultElements, ...extraElements])
                                        }
                                    ]
                                }
                            ],
                            "document_form_data": [{}],
                            "document_response_data": [],
                            [`${dbName}_x_document_data`]: [{
                                ...defaultValues
                            }]
                        }
                    ],
                }
            }
        }
        //新增
        let postData = [defaultMainPostData]
        MainApiController.postData(postData)
    }
    /**
     * 根據目前的下拉選單選擇（templateSelectionDataChanged）與需求描述（aiPrompt），
     * 呼叫 AI 元件數量建議 API，並將回傳的建議數量更新到 ComponentQuantityPanel。
     *
     * payload 說明：
     *   - target：固定為「文案」
     *   - input：送給 AI 的元件型別清單（從 conponentDefinitionsController 取得）
     *   - output：告知 AI 回傳格式（固定範本）
     *   - 其餘欄位：從下拉選單選擇整理出的特色描述（發布形式、產業別 … 等）
     *
     * 回傳格式：
     *   { status: "success", message: { "title": 2, "image": 3, ... } }
     *   message 的 key 為 component_type，需對應回 component_definitions_id。
     */
    const handleAISuggest = async () => {
        const componentDefinitions = conponentDefinitionsController?.ResponseData || []

        const componentTypes = componentDefinitions
            .map((raw) => raw?.component_definitions_classify_structure_type_data?.[0]?.component_type)
            .filter(Boolean)

        if (componentTypes.length === 0) {
            message.warning('尚未載入元件資料，請稍後再試')
            return
        }

        // templateSelectionDataChanged 格式：
        // { "發布形式分類": [{ id, value }], "專用產業別": [{ id, value }], ... }
        // 把每個 key 的 value 陣列用頓號合併成字串，直接展開進 payload
        const selectionExtras = {}
        if (templateSelectionDataChanged && typeof templateSelectionDataChanged === 'object') {
            Object.entries(templateSelectionDataChanged).forEach(([key, options]) => {
                if (Array.isArray(options) && options.length > 0) {
                    selectionExtras[key] = options.map((opt) => opt?.value).filter(Boolean).join('、')
                }
            })
        }

        if (aiPrompt?.trim()) {
            selectionExtras['需求描述'] = aiPrompt.trim()
        }

        const target = '文案'
        const payload = [
            {
                target,
                input: { [target]: componentTypes },
                output: { [target]: [componentTypes.map((type) => `${type}數量N個`).join('、')] },
                ...selectionExtras,
            },
        ]

        const result = await aiQuantityController.postData(payload, "raw")

        if (result?.status !== 'success' || !result?.values?.message) {
            message.error('AI 建議取得失敗，請稍後再試')
            return
        }

        const aiMessage = result.values.message
        const nextCounts = { ...componentQuantityCounts }

        componentDefinitions.forEach((raw) => {
            const id = raw?.component_definitions_id
            const componentType = raw?.component_definitions_classify_structure_type_data?.[0]?.component_type
            if (id && componentType && aiMessage[componentType] !== undefined) {
                nextCounts[id] = aiMessage[componentType]
            }
        })

        setComponentQuantityCounts(nextCounts)
        message.success('AI 元件數量建議已更新')
    }
    // ──────────────────────────────────────────────────────────────────────────

    const TemplateStatisticsController =
        useCRUDController({
            onFinish: TemplateonStatisticsFinish,
            onBefore: TemplateonStatisticsBefore,
            apiRoute: "/space_management/backend/template/statistics",
        });
    const FolderController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (axiosMode === "get") {
                    setFolderLoading(false)
                }
            },
            onBefore: ({ axiosMode, status, values }) => {
                if (axiosMode === "get") {
                    setFolderLoading(true)
                }
            },
            apiRoute: finalFolderApiRoute,
        });

    const TemplateController =
        useCRUDController({
            onFinish: TemplateFinish,
            onBefore: TemplateBefore,
            apiRoute: "/space_management/backend/template",
        });

    const SelectionController =
        useCRUDController({
            onFinish: () => { },
            onBefore: () => { },
            apiRoute: finalSelectionApiRoute,
        });
    const ArchitectureController =
        useCRUDController({
            onFinish: () => { },
            onBefore: () => { },
            apiRoute: referenceArchitectureAPIRoute,
        });
    const MainApiController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success(t('新增成功'))
                        navigate(`${pageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: values?.[dbCoverIdName] }))
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error(t('新增失敗'))
                    }
                }
                setIsLoading(false)
            },
            onBefore: ({ axiosMode, status, values }) => {
                setIsLoading(true)
            },
            apiRoute: finalMainApiRoute,
        });
    const conponentDefinitionsController = useCRUDController({
        apiRoute: componentDefinitionsApiRoute,
    })
    const aiQuantityController = useCRUDController({
        apiRoute: '/utility/ai_produce_quantity_recommendations',
    })
    const AiControllers = useCRUDController({ apiRoute: "/utility/ai_produce/controller/quantity_recommendations", onFinish: () => { }, onBefore: () => { } })

    useEffect(() => {
        TemplateStatisticsController.getData()
        FolderController.getData().then((response) => {
            let data = response?.data || []
            setFolderData(data)
        })
        getSelectionData()
        if (isReferenceArchitecture) {
            getArchitectureData()
        }
        conponentDefinitionsController.getData()
    }, [])

    return (
        <div className="container-fluid max-w-full">
            <CrmContainerTitle1_1
                pageTitleProps={
                    {
                        pageTitleProps: {
                            title: t('建立') + propsCategoryName + propsCategoryTitle,
                            subTitle: '',
                            color: propsPrimaryColor,   // text-teal-800
                            subTitlecolor: propsSecodaryColor,   // text-teal-600
                            bgcolor: { backgroundImage: propsBackgroundColor },
                        },
                    }
                }
            />

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                <div className="lg:col-span-4">
                    <CrmContainerTitle1_1
                        pageTitleProps={
                            {
                                pageTitleProps: {
                                    title: t('選擇建立方式'),
                                    subTitle: t('請選擇一種方式開始建立您的') + propsCategoryName + propsCategoryTitle,
                                    color: propsPrimaryColor,   // text-teal-800
                                    subTitlecolor: propsSecodaryColor,   // text-teal-600
                                    bgcolor: { backgroundImage: propsBackgroundColor },
                                },
                                needSecondTitle: true,
                                secondTitle: t('操作指引'),
                                secondTitleColor: propsSecodaryColor,
                                secondTitleBgcolor: propsBackgroundColor,
                                secondTitleIconBgcolor: propsSecodaryColor,
                                secondTitleDescriptionBgcolor: { backgroundImage: propsBackgroundColor },
                                secondTitleDescriptionColor: propsPrimaryColor,   /* text-teal-700 */
                                secondTitleDescription: t('請先選擇一種建立方式，然後依照編號順序填寫必要資訊，進入') + propsCategoryName + propsCategoryTitle + t('編輯頁面。')
                            }
                        }
                    />
                    <CrmCategoryMenu1_1
                        TabsProps={
                            {
                                activeKey: 'new',
                                defaultActiveKey: 'new',
                                items: [
                                    {
                                        key: 'new',
                                        tab: zeroCreateName + t('建立') + propsCategoryName + propsCategoryTitle + (displayAIGenerate ? t('與AI生成') : ''),
                                        BlockA: {
                                            basicData: {
                                                iconLabel: 'A',
                                                tabDescription: t('從零開始建立一個全新的空白') + propsCategoryTitle + t('您可以自由添加各種內容和格式。'),
                                                tabDescriptionStyle: '',
                                                titleIcon: < Plus className="mr-2 h-4 w-4" />,
                                                title: zeroCreateName + t('建立空白') + propsCategoryTitle,
                                                content: '',
                                                processText: t('處理中') + "...",
                                            },
                                            formData: [
                                                {
                                                    label: propsCategoryTitle + '名稱',
                                                    value: '',
                                                    placeholder: t('輸入') + propsCategoryTitle + t('名稱，例如：產品介紹') + propsCategoryTitle,
                                                },
                                                {
                                                    label: propsCategoryTitle + '描述',
                                                    value: '',
                                                    placeholder: t('描述這個') + propsCategoryTitle + t('的用途和特色'),
                                                },
                                                {
                                                    label: propsCategoryTitle + '儲存資料夾',
                                                    value: '',
                                                    placeholder: t('請選擇'),
                                                },
                                            ]
                                        },
                                        BlockB: {
                                            basicData: {
                                                iconLabel: 'B',
                                                tabDescription: t('描述您需要的') + propsCategoryTitle + t('類型、內容和功能，AI將根據您的描述和屬性設定生成') + propsCategoryTitle + '。',
                                                tabDescriptionStyle: '',
                                                titleIcon: < Plus className="mr-2 h-4 w-4" />,
                                                title: t('AI生成') + propsCategoryTitle,
                                                content: '',
                                                processText: t('處理中') + "...",
                                            },
                                            formData: [
                                                {
                                                    label: t('需求描述'),
                                                    description: t('(文字描述或上傳檔案至少提供一項)'),
                                                    value: '',
                                                    placeholder: t('例如：我需要一個') + propsCategoryTitle + t('介紹') + propsCategoryName + t('包含特點和使用場景'),
                                                    hint: t('提示：描述越詳細，AI生成的') + propsCategoryName + t('越符合您的需求。'),
                                                },
                                                {
                                                    label: propsCategoryTitle + '儲存資料夾',
                                                    value: '',
                                                    placeholder: t('請選擇'),
                                                },
                                                {
                                                    label: t('上傳參考資料'),
                                                    description: t('您可以上傳圖片、影片、音檔或文件作為參考資料'),
                                                    value: '',
                                                },
                                            ]
                                        }
                                    },
                                    {
                                        key: 'default',
                                        tab: t('系統預設') + propsCategoryTitle,
                                    },
                                ],
                                onChange: () => { },
                                centered: false,
                                tabBarExtraContent: "",
                                tabsStyle: {
                                    width: "100%",        // w-full
                                    paddingLeft: "1rem",  // px-4 → 1rem
                                    paddingRight: "1rem",
                                    paddingBottom: "1rem" // pb-4 → 1rem
                                },
                                tabsListStyle: {
                                    display: "grid",                                      // grid
                                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",     // grid-cols-2
                                    backgroundColor: "bg-" + propsPrimaryColorName + "-100"                            // bg-teal-100
                                },
                                tabsTriggerStyle: {
                                    display: "flex",        // flex
                                    flexDirection: "column",// flex-col
                                    height: "auto"          // h-auto
                                },
                                showRenderFunction: true,
                                renderFunction: (item) => { return (TabContentRenderFunction(item)) },
                            }
                        }
                    />


                </div>
                {/* 右側統計面板 */}
                <BaseChart
                    primaryTheme={propsPrimaryColorName}
                    secondaryTheme={propsPrimaryColorName}
                    baseChart1Value={{
                        title: t('分類與建立方式分佈'),
                        data: chartData?.chart1?.data
                    }}
                    baseChart2Value={{
                        title: t('範本總覽'),
                        stats: chartData?.chart2?.data ?? []
                    }}
                    baseChart3Value={{
                        title: t('建立方式'),
                        items: chartData?.chart3?.data
                    }}
                    baseChart4Value={{
                        title: t('建立方式'),
                        chartData: chartData?.chart4?.data,
                        chartConfig: chartData?.chart4?.config,
                        xDataKeyArr: ["label"],
                        yDataKeyArr: ["value"]
                    }}
                />
            </div>
        </div>
    )
}

export default Name2
